

























import ExchangeCard from "@/shared/components/molecules/ExchangeCardMolecule.vue"
import InputAtom from "@/shared/components/atoms/InputAtom.vue"
import { defineComponent, WritableComputedRef, computed, ComputedRef } from "@vue/composition-api"
import { useActions, useGetters } from "vuex-composition-helpers"
import { Insurance } from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"

export default defineComponent({
    name: "ExchangeInsurance",
    components: { ExchangeCard, InputAtom },
    setup() {
        const {
            getLabels,
            getInsurance,
            isEditable
        } = useGetters([
            'getLabels',
            'getInsurance',
            'isEditable'
        ])
        const {
            setInsurance
        } = useActions([
            'setInsurance'
        ])

        const insurance: WritableComputedRef<Insurance> = computed({
            get(): Insurance {
                return getInsurance.value
            },
            set(value: Insurance): void {
                setInsurance(value)
            }
        })
        
        const disabled: ComputedRef<boolean> = computed(() => !isEditable.value)

        function handleInput(value: boolean) {
            insurance.value = {
                agreement: value,
                completed: value
            }
        }
        
        return {
            getLabels,
            insurance,
            disabled,
            handleInput
        }
    }
})
